import { render, staticRenderFns } from "./SConfirmDialog.vue?vue&type=template&id=1c402692&scoped=true"
import script from "./SConfirmDialog.vue?vue&type=script&lang=js"
export * from "./SConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c402692",
  null
  
)

export default component.exports